import { render, staticRenderFns } from "./ModalSurveyQuestion.vue?vue&type=template&id=c83aa8d6&scoped=true&"
import script from "./ModalSurveyQuestion.vue?vue&type=script&lang=js&"
export * from "./ModalSurveyQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ModalSurveyQuestion.vue?vue&type=style&index=0&id=c83aa8d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83aa8d6",
  null
  
)

export default component.exports